import React from "react";

const CustomMessage = ({
  closeTray,
  content,
  setContent,
  handleSendMessage,
  loading,
}) => {
  return (
    <div style={{ marginTop: "12px" }}>
      <div className="input-group d-flex flex-column gap-3 mt-1">
        <textarea
          className="form-control form-control-sm w-100 shadow-lg rounded-3"
          placeholder="Type your message here"
          style={{ height: "100px" }}
          value={content}
          onChange={(e) => setContent(e.target.value)}
        />
        <div className="w-100 btn btn-primary rounded-3">
          {loading ? (
            <div className="spinner-border spinner-border-sm" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          ) : (
            <div onClick={handleSendMessage}>Send</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CustomMessage;
